import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import HintMessage from 'components/HintMessage';
import SparklesIcon from 'icons/Sparkles.icon';
import useAiDraftedListing from '../../hooks/useAiDraftedListing';
import useAiDraftBannerDismissal from './hooks';
import { AI_DRAFT_BANNER_COPY, AiDraftBannerStep } from './utils';

type AiDraftBannerProps = {
  className?: string;
  step: AiDraftBannerStep;
};

const AiDraftBanner: React.FC<AiDraftBannerProps> = (props) => {
  const { className, step } = props;

  const { listingId, isAiDrafted, documentName } = useAiDraftedListing();

  const { isDismissed, dismiss } = useAiDraftBannerDismissal(listingId, step);

  const { t } = useTranslation();

  const classes = classNames('ai-draft-banner', className);

  if (!isAiDrafted || isDismissed) return null;

  return (
    <HintMessage
      className={classes}
      icon={<SparklesIcon />}
      message={t(AI_DRAFT_BANNER_COPY[step], { documentName })}
      onClose={dismiss}
    />
  );
};

export default AiDraftBanner;
